import { render, staticRenderFns } from "./ProductQuoteList.vue?vue&type=template&id=2aea2446&scoped=true"
import script from "./ProductQuoteList.vue?vue&type=script&lang=js"
export * from "./ProductQuoteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aea2446",
  null
  
)

export default component.exports